import landing from '@/locales/gt/landing'
import resultOrder from '@/locales/gt/result-order'
import invoice from '@/locales/gt/invoice'
import microcredits from '@/locales/gt/microcredits'
import invoiceMcw from '@/locales/gt/invoice-mcw'
import internetOnDemand from '@/locales/gt/internet-on-demand'
import currency from '@/locales/gt/currency'
import history from '@/locales/gt/history'
import turnOn3G from '@/locales/gt/turn-on-3g'
import genericError from '@/locales/gt/generic-error'
import maintenance from '@/locales/gt/maintenance'
import buyRecharges from '@/locales/gt/buy-recharges'
import latePayment from '@/locales/gt/late-payment'

export default {
  landing,
  resultOrder,
  invoice,
  microcredits,
  invoiceMcw,
  internetOnDemand,
  currency,
  history,
  turnOn3G,
  genericError,
  maintenance,
  buyRecharges,
  latePayment
}
